/**
 * Runs `task` after the browser has a chance to paint the current React update
 * (e.g. selected tab chrome) before heavier route work begins.
 */
export function scheduleAfterPaint(task: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(task)
  })
}
